import { useEffect, useState } from 'react';

import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartDisplay } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { ChartsProps } from '../types';
import { AppWatch } from '@wajeez/wajeez.microservices';
import { Select } from 'antd';

const DailyBreakdownByPurchaseSurceChart = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const {
    dailyBreakdownByPurchaseSurceFiltered,
    dailyBreakdownByPurchaseSurceFilteredStatus,
  } = useAppwatchSelector((c) => c.paymentAnalysis);
  const [purchaseSource, setPurchaseSource] =
    useState<AppWatch.PurchaseSourceType>(
      AppWatch.PurchaseSourceType.CARD_DIRECT
    );
  useEffect(() => {
    dispatch(
      PaymentAnalysisActions.getDailyBreakdownByPurchesFilteredSourceAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
        purchaseSourceType: purchaseSource,
      })
    );
  }, [dates, purchaseSource]);

  return (
    <div className="col-span-2">
      {' '}
      <Card>
        <div className="space-y-2">
          <div className="flex flex-row justify-between">
            <ChartHeader
              title="daily Breakdown By Purchase Surce"
              dates={dates}
            />
            <Select
              className="w-[160px]"
              value={purchaseSource}
              onChange={(e) => setPurchaseSource(e)}
              options={[
                {
                  label: 'CARD',
                  value: AppWatch.PurchaseSourceType.CARD_DIRECT,
                },
                { label: 'DCP', value: AppWatch.PurchaseSourceType.DCP_WALLET },
                { label: 'FREE', value: AppWatch.PurchaseSourceType.FREE },
                {
                  label: 'INSTALLMENT_PLAN',
                  value: AppWatch.PurchaseSourceType.INSTALLMENT_PLAN,
                },
                {
                  label: 'INTERNAL',
                  value: AppWatch.PurchaseSourceType.INTERNAL,
                },
                {
                  label: 'MOBILE_STORE',
                  value: AppWatch.PurchaseSourceType.MOBILE_STORE,
                },
                {
                  label: 'OFFLINE',
                  value: AppWatch.PurchaseSourceType.OFFLINE,
                },
                {
                  label: 'VOUCHER',
                  value: AppWatch.PurchaseSourceType.VOUCHER,
                },
                { label: 'Other', value: AppWatch.PurchaseSourceType.Other },
              ]}
            />
          </div>

          <ChartDisplay
            loading={dailyBreakdownByPurchaseSurceFilteredStatus === 'loading'}
            chartType="bar"
            xAxistype="datetime"
            chart={{
              type: 'bar',

              stacked: true,
            }}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            seriesData={Array.from(
              new Set(
                dailyBreakdownByPurchaseSurceFiltered.map(
                  (d) => d.purchase_Source_Type || ''
                )
              )
            )?.map((element) => ({
              name: element,
              data: dailyBreakdownByPurchaseSurceFiltered
                .filter((d) => d.purchase_Source_Type === element)
                .map((d) => ({
                  y: d.count || '',

                  x: d.startDate || '',
                })),
            }))}
          />
        </div>
      </Card>
    </div>
  );
};

export default DailyBreakdownByPurchaseSurceChart;
